// Auto-generated normalizer for table: NivelJerarquico
export function nivelJerarquicoNormalize(row) {
  return {
    idNivelJerarquico: row.idNivelJerarquico ?? row.IdNivelJerarquico ?? row['IdNivelJerarquico'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
